import type { RouteObject } from 'react-router-dom'
import Layout from '@/components/feature/Layout'
import NotFound from '@/pages/NotFound'
import Home from '@/pages/home/page'
import CategoryPage from '@/pages/category/page'
import ArticlePage from '@/pages/article/page'
import AboutPage from '@/pages/about/page'

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/category/:slug',
        element: <CategoryPage />,
      },
      {
        path: '/article/:id',
        element: <ArticlePage />,
      },
      {
        path: '/about',
        element: <AboutPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]

export default routes